import { PaginationStore } from '@storage/app/store/pagination.store'

export class ContainerTurnoversPaginationStore extends PaginationStore {
  constructor() {
    super({ pageSize: 15 })
  }
}
